export default {
  optional: 'Facultatif',
  agreeField: 'Veuillez lire et accepter le préavis',
  radioCheckbox: 'Veuillez répondre à la question',
  birthDate: {
    max: "L'âge saisi est au-dessus du maximum permis.",
    min: "L'âge saisi est inférieur au minimum permis.",
  },
};
